<inthraction-employee-dashboard *ngIf="ready" [employee]="employee" [manager]="manager"></inthraction-employee-dashboard>
